export default function polyfills () {
	window.requestAnimFrame = (function () {
		return (
			window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function (/* function */ callback) {
				window.setTimeout(callback, 1000 / 60); // 60fps
			}
		);
	}());

	window.cancelAnimFrame = (function () {
		return (
			window.cancelAnimationFrame ||
			window.webkitCancelAnimationFrame ||
			window.mozCancelAnimationFrame ||
			window.oCancelAnimationFrame ||
			window.msCancelAnimationFrame ||
			function (id) {
				window.clearTimeout(id);
			}
		);
	}());

	/*
	 * Avoid `console` errors in browsers that lack a console.
	 * @return {[type]} [description]
	 */
	{
		let method;
		const noop = () => {};
		const methods = [
			'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
			'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
			'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
			'timeStamp', 'trace', 'warn'
		];
		let length = methods.length;
		const console = (window.console = window.console || {});

		while (length--) {
			method = methods[length];

			// Only stub undefined methods.
			if (!console[method]) {
				console[method] = noop;
			}
		}
	}

	/**
	 * FindIndex polyfill
	 */
	if (!Array.prototype.findIndex) {
		// eslint-disable-next-line no-extend-native
		Object.defineProperty(Array.prototype, 'findIndex', {
			value: function (predicate) {
				// 1. Let O be ? ToObject(this value).
				if (this === null) {
					throw new TypeError('"this" is null or not defined');
				}

				let o = Object(this);

				// 2. Let len be ? ToLength(? Get(O, "length")).
				let len = o.length >>> 0;

				// 3. If IsCallable(predicate) is false, throw a TypeError exception.
				if (typeof predicate !== 'function') {
					throw new TypeError('predicate must be a function');
				}

				// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
				let thisArg = arguments[1];

				// 5. Let k be 0.
				let k = 0;

				// 6. Repeat, while k < len
				while (k < len) {
					// a. Let Pk be ! ToString(k).
					// b. Let kValue be ? Get(O, Pk).
					// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
					// d. If testResult is true, return k.
					let kValue = o[k];
					if (predicate.call(thisArg, kValue, k, o)) {
						return k;
					}
					// e. Increase k by 1.
					k++;
				}

				// 7. Return -1.
				return -1;
			}
		});
	}

	/**
	 * Custom event support for IE
	 */
	(function () {
		if (typeof window.CustomEvent === 'function') return false;

		function CustomEvent (event, params) {
			params = params || { bubbles: false, cancelable: false, detail: undefined };
			let evt = document.createEvent('CustomEvent');
			evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
			return evt;
		}

		CustomEvent.prototype = window.Event.prototype;

		window.CustomEvent = CustomEvent;
	})();
}